export default "__VITE_ASSET__i56lo4uV__"